<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de facturas entrantes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-factura-entrante` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2 mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nueva factura</span>
        </v-tooltip>
        <div style="display: flex; gap: 10px; margin-top: 10px;">
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        @click="provisional_dialog = true"
                        :loading="isloading"
                        :disabled="isloading"
                        color="green darken-1"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text">mdi-cash</v-icon>
                    </v-btn>
                </template>
                <span>Abono provisional</span>
            </v-tooltip>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        @click="imprimirLista"
                        :loading="isloading"
                        :disabled="isloading"
                        color="blue darken-1"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-printer</v-icon
                        >
                    </v-btn>
                </template>
                <span>Imprimir lista</span>
            </v-tooltip>
        </div>

        <v-row>
            <v-col cols="12" md="4">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros"
                ></FilterComponentVue>
                <v-checkbox
                    v-model="pendientes"
                    label="Pendientes"
                ></v-checkbox>
            </v-col>
        </v-row>

        <v-data-table
            dense
            @click:row="
                (item) => {
                    $router.push(`/guardar-factura-entrante?id=${item.id}`);
                }
            "
            :item-class="getRowClass"
            :headers="headers"
            :items="Facturas"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            :server-items-length="total_facturas"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.fecha="{ item }">
                <span v-if="item.fecha">{{ item.fecha | format_date }}</span>
                <span v-else style="color: red">No asignada</span>
            </template>
            <template v-slot:item.cobrado="{ item }">
                <span
                    :style="{
                        color: facturaEntranteSaldada(item) ? 'green' : 'orange',
                    }"
                >
                    {{ formatPrice(item.cobrado ?? 0) }}€</span
                >
            </template>
            <template v-slot:item.abono_pendiente="{ item }">
                <span
                    :style="{
                        color: facturaEntranteSaldada(item)
                            ? 'green'
                            : 'orange',
                    }"
                >
                    {{ displayPendienteEntrante(item) }}€
                </span>
            </template>
            <template v-slot:item.total="{ item }">
                <span>{{ formatPrice(item.total_a_pagar ?? item.total) }}€</span>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        @click="openModal(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
                <a
                    v-if="item.abono_pendiente !== 0"
                    @click.stop="openPagoModal(item)"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="ABONO"
                        >mdi-cash</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <!-- Modal para eliminar factura -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para guardar abono provisional -->
        <v-dialog v-model="provisional_dialog" max-width="600px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar abono provisional
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row class="mt-3">
                        <v-col cols="12" md="6">
                            <dynamicSelectVue
                                ref="dynamicSelectProveedor"
                                title="Proveedor"
                                :value="abono.id_proveedor"
                                max-width="800px"
                                outlined
                                @create="saveProveedor"
                                @delete="deleteProveedor"
                                @getEstado="getProveedorId"
                                @update="saveProveedor"
                                @changeElement="changeProveedor"
                            >
                                <v-form
                                    ref="formProveedor"
                                    v-model="validFormProveedor"
                                >
                                    <v-row class="mt-3">
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.nombre"
                                                label="Nombre"
                                                :rules="[rules.required]"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="
                                                    proveedor.nombre_fiscal
                                                "
                                                label="Nombre fiscal"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.cif"
                                                label="CIF"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.email"
                                                label="Email"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.telefono"
                                                label="Teléfono"
                                                required
                                                :rules="[rules.phone_rule]"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="8">
                                            <v-text-field
                                                outlined
                                                label="Dirección"
                                                v-model="proveedor.direccion"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.cp"
                                                label="CP"
                                                required
                                                :rules="[rules.number_rule]"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.poblacion"
                                                label="Población"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-autocomplete
                                                outlined
                                                v-model="proveedor.provincia"
                                                label="Provincia"
                                                required
                                                :items="provincias"
                                                item-text="nombre"
                                                item-value="nombre"
                                                dense
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.pais"
                                                label="País"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                            <v-textarea
                                                outlined
                                                v-model="
                                                    proveedor.observaciones
                                                "
                                                label="Observaciones"
                                                dense
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </dynamicSelectVue>
                        </v-col>
                        <v-col cols="12" md="6">
                            <date-select
                                v-model="abono.fecha"
                                label="Fecha"
                                outlined
                            >
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                                outlined
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            provisional_dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para restante por pagar -->
        <v-dialog v-model="pago_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 mt-3 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Restante por pagar
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>Importe pendiente por pagar</h2>
                    <v-row class="mt-3">
                        <v-col cols="12" md="6">
                            <date-select
                                v-model="abono.fecha"
                                label="Fecha"
                                outlined
                            >
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                                outlined
                                suffix="€"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            pago_dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";
import dynamicSelectVue from "../../../components/general/dynamicSelect.vue";
import { rules } from "../../../rules";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import { formatPrice } from "../../../helpers";
import {
    startOfMonth,
    endOfMonth,
} from "../../../components/general/DateFunctions";

export default {
    components: {
        dynamicSelectVue,
        FilterComponentVue,
    },
    data() {
        return {
            pendientes: false,
            filtros: {},
            filter_headers: [
                {
                    title: "Proveedor",
                    type: "select",
                    active: false,
                    model: "id_proveedor",
                    items: [],
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado de pago",
                    type: "select",
                    active: false,
                    model: "estado",
                    items: [
                        { id: 0, nombre: "Pendiente" },
                        { id: 1, nombre: "Pagada" },
                    ],
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Fecha de emisión",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Fecha de vencimiento",
                    type: "date",
                    active: false,
                    model: "fecha_vencimiento",
                },
                {
                    title: "Importe",
                    type: "number",
                    active: false,
                    model: "importe",
                    label: "Importe",
                    suffix: "€",
                },
            ],
            total_facturas: 0,
            page: 1,
            amount: 15,
            cantidad: 15,
            search: "",
            headers: [
                {
                    text: "Nº del sistema",
                    value: "system_number",
                    sortable: false,
                },
                { text: "Fecha de emisión", value: "fecha", sortable: false },
                {
                    text: "Nº del proveedor",
                    value: "nro_proveedor",
                    sortable: false,
                },
                { text: "Nombre proveedor", value: "nombre", sortable: false },
                { text: "CIF/NIF", value: "cif", sortable: false },
                { text: "Fecha(s) vencimiento", value: "fecha_vencimiento", sortable: false },
                { text: "Método de pago", value: "metodo_pago", sortable: false },
                { text: "Total a pagar", value: "total" },
                { text: "Total pendiente", value: "abono_pendiente" },
                { text: "Total abonado", value: "cobrado" },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Facturas: [],
            abono: {
                id: null,
                id_factura: this.$route.query.id,
                id_proveedor: null,
                fecha: null,
                importe: null,
            },
            selectedItem: 0,
            provisional_dialog: false,
            pago_dialog: false,
            dialog: false,

            proveedor: {
                id: null,
                nombre: "",
                nombre_fiscal: "",
                cif: "",
                telefono: "",
                direccion: "",
                cp: "",
                poblacion: "",
                provincia: "",
                pais: "",
                observaciones: "",
                email: "",
            },
            validFormProveedor: true,
            rules: rules,
        };
    },
    created() {
        // Inicializar fecha_vencimiento con valores por defecto
        /*this.$set(this.filtros, "fecha_vencimiento", {
            start: startOfMonth(),
            end: endOfMonth(),
        });*/
        this.$store.dispatch("getProveedores", this);
        this.filter_headers[0].items = this.$store.getters.getproveedores;
    },
    watch: {
        filtros: {
            deep: true,
            handler: debounce(function (val) {
                this.getFacturas();
            }, 500),
        },
        pendientes: function (val) {
            this.getFacturas();
        },
    },
    methods: {
        /** Importe pendiente real (viene del API: total a pagar ± abonos registrados). */
        displayPendienteEntrante(item) {
            return this.formatPrice(item.abono_pendiente ?? 0);
        },
        facturaEntranteSaldada(item) {
            const p = parseFloat(item.abono_pendiente) || 0;
            return Math.abs(Math.round(p * 100) / 100) < 0.01;
        },
        getRowClass(item) {
            return "pointer";
        },
        ChangeSize(event) {
            this.amount = event;
            this.getFacturas();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getFacturas();
        },
        getFacturas() {
            axios
                .get(`api/get-facturas-entrantes`, {
                    params: {
                        page: this.page,
                        amount: this.amount,
                        search: this.filtros.search,
                        fecha_desde: this.filtros.fecha?.start,
                        fecha_hasta: this.filtros.fecha?.end,
                        id_proveedor: this.filtros.id_proveedor?.value,
                        fecha_vencimiento_desde:
                            this.filtros.fecha_vencimiento?.start,
                        fecha_vencimiento_hasta:
                            this.filtros.fecha_vencimiento?.end,
                        estado: this.filtros.estado?.value,
                        importe: this.filtros.importe?.value,
                        pendientes: this.pendientes ? "true" : "false",
                    },
                })
                .then(
                    (res) => {
                        const items = res.data.data || [];
                        this.Facturas = this.pendientes
                            ? items.filter(
                                  (f) =>
                                      Math.round(
                                          Math.abs(f.abono_pendiente ?? 0) * 100
                                      ) / 100 !== 0
                              )
                            : items;
                        this.total_facturas = res.data.total;
                    },
                    (err) => {
                        this.$custom_error("Error consultando las facturas");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Facturas.indexOf(item);
            this.dialog = true;
        },
        openPagoModal(item) {
            this.abono.id_factura = item.id;
            this.abono.id_proveedor = item.id_proveedor;
            this.abono.fecha = new Date().toISOString().slice(0, 10);
            this.abono.importe = item.abono_pendiente < 0 ? Math.abs(item.abono_pendiente) : item.abono_pendiente;
            this.pago_dialog = true;
        },
        SaveAbono() {
            axios.post(`api/save-abono-entrante`, this.abono).then(
                (res) => {
                    this.$toast.sucs("Abono guardado con éxito");
                    this.pago_dialog = false;
                    this.provisional_dialog = false;
                    this.getFacturas();
                },
                (err) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                }
            );
        },
        deleteUser() {
            axios
                .get(
                    `api/delete-factura-entrante/${
                        this.Facturas[this.selectedItem].id
                    }`
                )
                .then(
                    (res) => {
                        this.$toast.sucs("Factura eliminada con éxito");
                        this.dialog = false;
                        this.getFacturas();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando la factura");
                    }
                );
        },

        // Funciones de dynamicSelect proveedor
        saveProveedor() {
            this.$refs.formProveedor.validate();
            if (!this.validFormProveedor) return;
            axios
                .post("api/save-proveedor", this.proveedor)
                .then((res) => {
                    this.$refs.dynamicSelectProveedor.closeDialog();
                    this.$toast.sucs("Proveedor guardado con éxito");
                    this.clearProveedor();
                    this.$store.dispatch("getProveedores", this);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        deleteProveedor(id) {
            axios
                .post(`api/delete-proveedor`, { id: id })
                .then((res) => {
                    this.$toast.sucs("Proveedor eliminado con éxito");
                    this.$store.dispatch("getProveedores", this);
                    this.clearProveedor();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getProveedorId(id) {
            if (id != null) {
                axios
                    .get(`api/getproveedor/${id}`)
                    .then((res) => {
                        this.proveedor = res.data;
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        changeProveedor(id) {
            this.abono.id_proveedor = id;
            this.getFacturas();
        },
        clearProveedor() {
            this.proveedor = {
                id: null,
                nombre: "",
                nombre_fiscal: "",
                cif: "",
                telefono: "",
                direccion: "",
                cp: "",
                poblacion: "",
                provincia: "",
                pais: "",
                observaciones: "",
                email: "",
            };
        },

        formatPrice,
        async imprimirLista() {
            this.$store.dispatch("isLoading", true);
            
            try {
                const titulo = 'Lista de Facturas Entrantes';
                const fecha = new Date().toLocaleDateString('es-ES');
                
                const params = {
                    amount: -1,
                    search: this.filtros.search,
                    fecha_desde: this.filtros.fecha?.start,
                    fecha_hasta: this.filtros.fecha?.end,
                    id_proveedor: this.filtros.id_proveedor?.value,
                    fecha_vencimiento_desde: this.filtros.fecha_vencimiento?.start,
                    fecha_vencimiento_hasta: this.filtros.fecha_vencimiento?.end,
                    estado: this.filtros.estado?.value,
                    importe: this.filtros.importe?.value,
                    pendientes: this.pendientes ? "true" : "false",
                };
                
                const response = await axios.get(`api/get-facturas-entrantes`, { params });
                const todasLasFacturas = response.data.data;
                
                let totalFacturado = 0;
                let totalAbonado = 0;
                let totalPendiente = 0;
                todasLasFacturas.forEach(factura => {
                    totalFacturado += parseFloat(factura.total_a_pagar ?? factura.total ?? 0);
                    totalAbonado += parseFloat(factura.cobrado ?? 0);
                    totalPendiente += parseFloat(factura.abono_pendiente ?? 0);
                });
                
                let html = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="UTF-8">
                        <title>${titulo}</title>
                        <style>
                            @media print {
                                @page {
                                    margin: 1cm;
                                    size: A4 landscape;
                                }
                                body {
                                    margin: 0;
                                    padding: 0;
                                }
                            }
                            body {
                                font-family: Arial, sans-serif;
                                font-size: 10px;
                                padding: 20px;
                            }
                            h1 {
                                text-align: center;
                                margin-bottom: 10px;
                                font-size: 18px;
                            }
                            .info-header {
                                display: flex;
                                justify-content: space-between;
                                margin-bottom: 20px;
                                font-size: 11px;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 10px;
                            }
                            th, td {
                                border: 1px solid #ddd;
                                padding: 6px;
                                text-align: left;
                            }
                            th {
                                background-color: #1d2735;
                                color: white;
                                font-weight: bold;
                                text-align: center;
                            }
                            tr:nth-child(even) {
                                background-color: #f2f2f2;
                            }
                            .text-right {
                                text-align: right;
                            }
                            .totales {
                                margin-top: 20px;
                                display: flex;
                                justify-content: space-around;
                                font-weight: bold;
                                font-size: 12px;
                            }
                            .total-item {
                                padding: 10px;
                                background-color: #851e31;
                                color: white;
                                border-radius: 5px;
                                min-width: 150px;
                                text-align: center;
                            }
                        </style>
                    </head>
                    <body>
                        <h1>${titulo}</h1>
                        <div class="info-header">
                            <div>Fecha de impresión: ${fecha}</div>
                            <div>Total de registros: ${todasLasFacturas.length}</div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Nº Sistema</th>
                                    <th>Fecha</th>
                                    <th>Nº Proveedor</th>
                                    <th>Nombre proveedor</th>
                                    <th>CIF/NIF</th>
                                    <th>Fecha(s) vencimiento</th>
                                    <th>Método de pago</th>
                                    <th class="text-right">Total a pagar</th>
                                    <th class="text-right">Total pendiente</th>
                                    <th class="text-right">Total abonado</th>
                                </tr>
                            </thead>
                            <tbody>
                `;
                
                todasLasFacturas.forEach(factura => {
                    let fechaFormateada = '';
                    if (factura.fecha) {
                        const str = factura.fecha.split('-');
                        fechaFormateada = `${str[2]}-${str[1]}-${str[0]}`;
                    } else {
                        fechaFormateada = 'No asignada';
                    }
                    
                    const fechasVenc = factura.fecha_vencimiento != null ? factura.fecha_vencimiento : '';
                    const metodoPago = factura.metodo_pago != null ? factura.metodo_pago : '';
                    const totalAPagarCell = factura.importes_vencimiento && factura.importes_vencimiento.length > 0
                        ? factura.importes_vencimiento.map((imp) => this.formatPrice(imp)).join(' - ')
                        : this.formatPrice(factura.total_a_pagar ?? factura.total);
                    const pendienteImpreso = this.formatPrice(factura.abono_pendiente ?? 0);
                    const cobradoImpreso = this.formatPrice(factura.cobrado ?? 0);
                    html += `
                        <tr>
                            <td>${factura.system_number || ''}</td>
                            <td>${fechaFormateada}</td>
                            <td>${factura.nro_proveedor || ''}</td>
                            <td>${factura.nombre || ''}</td>
                            <td>${factura.cif || ''}</td>
                            <td>${fechasVenc}</td>
                            <td>${metodoPago}</td>
                            <td class="text-right">${totalAPagarCell}</td>
                            <td class="text-right">${pendienteImpreso}</td>
                            <td class="text-right">${cobradoImpreso}</td>
                        </tr>
                    `;
                });
                
                html += `
                            </tbody>
                        </table>
                        <div class="totales">
                            <div class="total-item">
                                <div>Total a pagar</div>
                                <div>${this.formatPrice(totalFacturado)}</div>
                            </div>
                            <div class="total-item">
                                <div>Total abonado</div>
                                <div>${this.formatPrice(totalAbonado)}</div>
                            </div>
                            <div class="total-item">
                                <div>Pendiente</div>
                                <div>${this.formatPrice(totalPendiente)}</div>
                            </div>
                        </div>
                    </body>
                    </html>
                `;
                    
                const ventanaImpresion = window.open('', '_blank');
                ventanaImpresion.document.write(html);
                ventanaImpresion.document.close();
                
                setTimeout(() => {
                    ventanaImpresion.print();
                }, 250);
            } catch (error) {
                this.$custom_error("Error al obtener las facturas para imprimir");
                console.error(error);
            } finally {
                this.$store.dispatch("isLoading", false);
            }
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        provincias: function () {
            return this.$store.getters.getprovincias;
        },
        proveedores() {
            const data = this.$store.getters.getproveedores;
            return data;
        },
    },
};
</script>
